export default {"src":"/_next/static/media/accuracy_blue.a3a802f1.svg","height":19,"width":19,"blurWidth":0,"blurHeight":0};